/* eslint-disable jira/filename-case */
import { useTenantContext } from '../tenant-context/index.tsx';

/**
 * is Jira admin (not "is project admin")
 * @agent-skills: tenant-context
 */
export const useIsAdmin = (): boolean => {
	const tenantContext = useTenantContext();
	return (tenantContext && tenantContext.isAdmin) || false;
};
